import md5 from 'blueimp-md5';
import cookie from 'js-cookie';
import { snakeKeys, camelKeys } from '@tencent/we-lib-variable-case';
import { getRoute, uuid, getQueryString } from './utils';
import { API_CONFIG, DEFAULT_ERROR_MESSAGES, ERROR_CODES } from './constant';
function request(api, data = {}) {
  try {
    return fetch(`/api/${api}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json;charset=utf-8' },
      credentials: 'same-origin',
      body: JSON.stringify(snakeKeys(data))
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then((raw) => {
        const response = camelKeys(raw);
        // rpc 开头的业务，数据格式不同，特殊处理
        if (/^rpc/.test(api)) {
          if (response.result === 0) {
            return response;
          }
          const error = new Error('');
          error.code = response.result;
          throw error;
        }
        const code = response.result.errorCode;
        if (code === 0) {
          return response;
        }
        let errorMessage = DEFAULT_ERROR_MESSAGES[code] || '内部错误';
        if (process.env.NODE_ENV !== 'production') {
          errorMessage += `(${code})`;
        }
        const error = new Error(errorMessage);
        error.code = code;
        throw error;
      });
  } catch (error) {
    throw error;
  }
}
function getTokens() {
  return {
    openId: cookie.get('open_id')
  };
}

function getCommonParams() {
  return {
    ...getTokens(),
    eventId: '202011101625' // mock
  };
}

export function wxOauth() {
  const id = uuid();
  cookie.set('mars_uuid', id);
  const st = id.replace(/-/g, '');
  const APPID = process.env.VUE_APP_WECHAT_APPID;
  const fullUrl = `${location.protocol}//${location.host}${location.pathname}`;
  const queryType = getQueryString('type');
  const queryUrl = queryType ? `${fullUrl}?type=${queryType}` : fullUrl;
  const routeName = getRoute();
  const url = routeName ? `${queryUrl}${routeName}` : queryUrl;
  location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent(
    url
  )}&response_type=code&scope=snsapi_userinfo&state=${st}#wechat_redirect`;
}

export function login({ uuid, code }) {
  try {
    return request(API_CONFIG.QUERY_COOKIE_TOKEN, {
      code,
      state: md5(uuid)
    }).then((result) => {
      const { wechatOpenId } = result;
      cookie.set('open_id', wechatOpenId);
    });
  } catch (e) {}
}

// 获取抢券信息——第一个接口去拉取，后台创建用户（后续接口需要依赖，不能异步同时拉取）
export function getScrambleCoupon() {
  try {
    return request(
      API_CONFIG.GET_SCRAMBLE_COUPONS_INFO,
      getCommonParams()
    ).catch((e) => {
      if (e.code === ERROR_CODES.INVALID_TOKEN) {
        wxOauth();
      }
      throw e;
    });
  } catch (error) {
    throw error;
  }
}

// 首页2个接口合并拉取，返券模块-获取返券信息，抽奖模块-获取抽奖模块信息

export function getActivityInfo() {
  try {
    const arrPromise = [
      // request(API_CONFIG.GET_SCRAMBLE_COUPONS_INFO, getCommonParams()),
      request(API_CONFIG.GET_REWARD_COUPONS_INFO, getCommonParams()),
      request(API_CONFIG.GET_LOTTERY_INIFO, getCommonParams())
    ];
    return Promise.all(arrPromise).catch((e) => {
      if (e.code === ERROR_CODES.INVALID_TOKEN) {
        wxOauth();
      }
      throw e;
    });
  } catch (error) {
    throw error;
  }
}

// 抢限量优惠券
export function scrambleCoupon(dayNo) {
  try {
    return request(API_CONFIG.SCRAMBLE_COUPON, {
      dayNo,
      ...getCommonParams()
    }).catch((e) => {
      if (e.code === ERROR_CODES.INVALID_TOKEN) {
        wxOauth();
      }
      throw e;
    });
  } catch (error) {
    throw error;
  }
}

// 返券模块-领取返券模块优惠券
export function receiveRewardCoupon(rewardPhase) {
  try {
    return request(API_CONFIG.RECEIVE_REWARD_COUPON, {
      rewardPhase,
      ...getCommonParams()
    }).catch((e) => {
      if (e.code === ERROR_CODES.INVALID_TOKEN) {
        wxOauth();
      }
      throw e;
    });
  } catch (error) {
    throw error;
  }
}

// 抽奖模块-抽奖
export function drawLottery() {
  try {
    return request(API_CONFIG.DRAW_LOTTERY, getCommonParams()).catch((e) => {
      if (e.code === ERROR_CODES.INVALID_TOKEN) {
        wxOauth();
      }
      throw e;
    });
  } catch (error) {
    throw error;
  }
}
// 获取奖品列表
export function getMyPrizes() {
  try {
    return request(API_CONFIG.GET_MY_PRIZES, getCommonParams()).catch((e) => {
      if (e.code === ERROR_CODES.INVALID_TOKEN) {
        wxOauth();
      }
      throw e;
    });
  } catch (error) {
    throw error;
  }
}

// 登记活动提醒
export function registerRemind() {
  try {
    return request(API_CONFIG.REGISTER_EVENT_REMIND, getCommonParams()).catch(
      (e) => {
        if (e.code === ERROR_CODES.INVALID_TOKEN) {
          wxOauth();
        }
        if (e.code === ERROR_CODES.EXCEED_REGISTER_TIME) {
          console.log('超过预约提醒时间');
        }
        throw e;
      }
    );
  } catch (error) {
    throw error;
  }
}
